var map = {
	"./a-list.svg": "./template/styles/icons/a-list.svg",
	"./a.svg": "./template/styles/icons/a.svg",
	"./account.svg": "./template/styles/icons/account.svg",
	"./accountFilled.svg": "./template/styles/icons/accountFilled.svg",
	"./accountHalloween.svg": "./template/styles/icons/accountHalloween.svg",
	"./accountHalloweenFilled.svg": "./template/styles/icons/accountHalloweenFilled.svg",
	"./accountHalloweenUnfilled.svg": "./template/styles/icons/accountHalloweenUnfilled.svg",
	"./accountUnfilled.svg": "./template/styles/icons/accountUnfilled.svg",
	"./alert.svg": "./template/styles/icons/alert.svg",
	"./backArrow.svg": "./template/styles/icons/backArrow.svg",
	"./bagFilled.svg": "./template/styles/icons/bagFilled.svg",
	"./bagUnfilled.svg": "./template/styles/icons/bagUnfilled.svg",
	"./bin.svg": "./template/styles/icons/bin.svg",
	"./burger.svg": "./template/styles/icons/burger.svg",
	"./chevron-right.svg": "./template/styles/icons/chevron-right.svg",
	"./close.svg": "./template/styles/icons/close.svg",
	"./communication-preferences.svg": "./template/styles/icons/communication-preferences.svg",
	"./emoji-content.svg": "./template/styles/icons/emoji-content.svg",
	"./emoji-happy.svg": "./template/styles/icons/emoji-happy.svg",
	"./heartFilled.svg": "./template/styles/icons/heartFilled.svg",
	"./heartFilledValentines.svg": "./template/styles/icons/heartFilledValentines.svg",
	"./heartPrideFilled.svg": "./template/styles/icons/heartPrideFilled.svg",
	"./heartUnfilled.svg": "./template/styles/icons/heartUnfilled.svg",
	"./heartUnfilledValentines.svg": "./template/styles/icons/heartUnfilledValentines.svg",
	"./icon-share-facebook-normal.svg": "./template/styles/icons/icon-share-facebook-normal.svg",
	"./icon-share-google-normal.svg": "./template/styles/icons/icon-share-google-normal.svg",
	"./icon-share-instagram-normal.svg": "./template/styles/icons/icon-share-instagram-normal.svg",
	"./icon-share-pinterest-normal.svg": "./template/styles/icons/icon-share-pinterest-normal.svg",
	"./icon-share-snapchat-normal.svg": "./template/styles/icons/icon-share-snapchat-normal.svg",
	"./icon-share-twitter-normal.svg": "./template/styles/icons/icon-share-twitter-normal.svg",
	"./icon-share-vk-normal.svg": "./template/styles/icons/icon-share-vk-normal.svg",
	"./icon-share-youtube-normal.svg": "./template/styles/icons/icon-share-youtube-normal.svg",
	"./minus.svg": "./template/styles/icons/minus.svg",
	"./notification-check-green.svg": "./template/styles/icons/notification-check-green.svg",
	"./notification-exclamation-orange.svg": "./template/styles/icons/notification-exclamation-orange.svg",
	"./notification-exclamation.svg": "./template/styles/icons/notification-exclamation.svg",
	"./notification.svg": "./template/styles/icons/notification.svg",
	"./orders.svg": "./template/styles/icons/orders.svg",
	"./plus.svg": "./template/styles/icons/plus.svg",
	"./returns.svg": "./template/styles/icons/returns.svg",
	"./search.svg": "./template/styles/icons/search.svg",
	"./selected.svg": "./template/styles/icons/selected.svg",
	"./sortdown.svg": "./template/styles/icons/sortdown.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./template/styles/icons recursive ^\\.\\/.*\\.svg$";


//////////////////
// WEBPACK FOOTER
// ./template/styles/icons ^\.\/.*\.svg$
// module id = ./template/styles/icons recursive ^\.\/.*\.svg$
// module chunks = client.sitechrome